<template>
  <div class="phrases-table">
    <div class="top-section">
      <div class="back-icon">
        <span class="icon is-size-3" @click="backIntentsTable()">
          <i class="fas fa-arrow-alt-circle-left"></i>
        </span>
      </div>
      <div class="title">
        <span class="title">{{ intentName }}</span>
      </div>
      <div class="close-icon">
        <span class="icon is-size-3" @click="closeTableView">
          <i class="fas fa-times"></i>
        </span>
      </div>
    </div>
    <div class="section mt-6">
      <table class="table">
        <tr>
          <th>{{ CONSTANTS.getCopy('INTENTSPHRASESTABLE_PHRASE') }}</th>
          <th class="has-text-right">{{ CONSTANTS.getCopy('INTENTSPHRASESTABLE_PHRASE_#') }}</th>
          <th class="has-text-right">{{ CONSTANTS.getCopy('INTENTSPHRASESTABLE_PHRASE_%') }}</th>
        </tr>
        <tr v-for="(phrase, index) in data.phrases" :key="index">
          <td>{{ phrase.phrase }}</td>
          <td class="has-text-right">{{ phrase.total }}</td>
          <td class="has-text-right">{{ phrase.percent }} %</td>
        </tr>
      </table>
    </div>
  </div>

</template>

<script>

export default {
  props: {
    data: Object,
    intentName: String
  },
  data () {
    return {

    }
  },
  methods: {
    backIntentsTable () {
      this.$emit('backIntentsTable')
    },
    closeTableView () {
      this.$emit('closeTableView')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Analytics/IntentsPhrasesTable.vue